module.exports = __webpack_public_path__ + "static/media/locked-dark-gray.204ec489.svg";